<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      :addText="handlePermission('monthSettlementExcel')?'导出Excel':''"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      @addNew="getDownload">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>结算年月:</label>
            <timeStampDatePicker placeholder="请输入" class="item" clearable type='month'
              v-model.trim="query.settlementDate"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>参保地:</label>
            <lk-input :disabled='true' :maxlength="100" placeholder="请输入" class="item" clearable
              v-model.trim="query.insurancePlace"></lk-input>
          </div>

          <div class="queryItem">
            <lk-button :loading='checkLoading' class="mr" type="primary" @click="monthStatementCheck">月度结算确认</lk-button>

          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import insurance from '../../../services/insurance';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';

export default {
  name: 'MonthStatementCheck',
  mixins: [
    mapState,
    queryMixins,

  ],
  components: {
    QueryFrame,
  },
  data() {
    return {
      checkLoading: false,
      query: {
        insurancePlace: 61990001,
      },
      columns: [{
        title: '年月',
        key: 'settlementDateStr',
        minWidth: 116,
      },
      {
        title: '参保地',
        key: 'insurancePlace',
        minWidth: 116,
      },
      {
        title: '是否确认成功',
        key: 'confirmStatusStr',
        minWidth: 116,
      },
      {
        title: '确认时间',
        key: 'confirmTimeStr',
        minWidth: 116,
      },
      {
        title: '确认人',
        key: 'confirmUserName',
        minWidth: 116,
      },
      {
        title: '备注',
        key: 'remark',
        minWidth: 116,
      }],
      tableData: [

      ],
    };
  },
  methods: {
    getData() {
      const { insurancePlace } = this.query;
      insurance.getSettlementList({
        insurancePlace,
      }).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          this.tableData = data.list.map((item) => {
            item.confirmStatusStr = this.publicParams.judgeList[item.confirmStatus];
            return item;
          });

          this.count = data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    monthStatementCheck() {
      this.checkLoading = true;
      insurance.confirmSettlement(this.query).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('确认成功');
        } else {
          this.$Message.error(res.data.error);
        }
        this.checkLoading = false;
      }).catch((err) => {
        this.checkLoading = false;
        utils.handleError(err);
      });
    },
    getDownload() {
      const params = Object.assign({}, this.params);
      delete params.page;
      delete params.size;
      insurance.monthSettlementExport(params).then((res) => {
        utils.downLoadExcel(res, '月度结算确认');
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getData();
  },
};


</script>
